import BaseModal from '@/vcs/_shared/modals/BaseModal.vue'
import toastStore from '@/stores/toast-store.js'
import axios from 'axios'

import AddDeliveryRequestPhone from '@/vcs/_shared/modals/add-delivery-request-phone/cmp.vue'

export default {
  name: 'AddDeliveryRequestStart',
  extends: BaseModal,
  data: function () {
    return {
      collectomates: [],
      blocker: false,
    }
  },
  mounted() {
    this.fetchCollectomates()
  },
  computed: {
    cpsWithByUserDeliveryScenario() {
      return this.collectomates.length
        ? this.collectomates.filter(cp => cp.deliveryScenarios.indexOf('by_user') != -1)
        : []
    },
  },
  methods: {
    fetchCollectomates: function (id) {
      this.blocker = true
      axios({
        method: 'get',
        url: 'collection_points',
      })
        .then(response => {
          this.collectomates = response.data
          this.blocker = false
          console.log('AddDeliveryRequestStart fetchCollectomates response', response)
        })
        .catch(error => {
          let errorMessage = error.response.data.errors
            ? Object.values(error.response.data.errors).join(', ')
            : this.$t('messages.error')
          toastStore.commit('error', { message: errorMessage })
          this.blocker = false
        })
    },

    selectCollectomate(collectionPoint) {
      this.$store.commit('modal/open', {
        cmp: AddDeliveryRequestPhone,
        animation: 'slide-left-modal',
        data: { collectionPoint: collectionPoint },
      })
    },
  },
  components: {
    Blocker: () => import('@/vcs/_shared/blocker/cmp.vue'),
  },
}
